import { Grid, Typography } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { GiLockedDoor } from 'react-icons/gi';
import QCXFormTitle from '../../../components/form-title/QCXFormTitle';
import QCXBox from '../../../shared-components/box/QCXBox';
import QCXButton from '../../../shared-components/button/QCXButton';

export default function UnauthorizedError({ handleClickReturn }) {
  const { t } = useTranslation();

  return (

    <Grid
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
    >
      <Grid item>
        <GiLockedDoor
          color="secondary"
          style={{
            width: '100%', height: '10vw', minHeight: '150px', color: '#F39200',
          }}
        />
      </Grid>
      <Grid item>
        <QCXFormTitle
          title={t('com.muralis.qcx.acessoNegado')}
        />
      </Grid>
      <Grid item>
        <Typography variant="h6" color="textSecondary" style={{ textAlign: 'justify', textAlignLast: 'center' }}>
          <QCXBox fontWeight="fontWeightBold" pt={5} pb={5}>
            {t('com.muralis.qcx.mensagem.semPermissaoSuficiente')}
          </QCXBox>
        </Typography>
      </Grid>
      <Grid item>
        <QCXButton
          onClick={handleClickReturn}
          color="primary"
        >
          {t('com.muralis.qcx.acoes.voltar')}
        </QCXButton>
      </Grid>

    </Grid>
  );
}
